export const BIDDING_STATUS = [
  {
    key: 1,
    value: '承諾が必要',
    color: 'yellow',
  },
  {
    key: 2,
    value: '承諾が必要<p>(繰り上げの可能性あり)</p>',
    color: 'yellow',
  },
  {
    key: 3,
    value: '承諾済み',
    color: 'yellow',
  },
  {
    key: 4,
    value: '落札取り消し',
    color: 'yellow',
  },
  {
    key: 10,
    value: '落札取り消し',
    color: 'yellow',
  },
];
export const SELLER_STATUS = [
  {
    key: 1,
    value: '落札承諾待ち',
  },
  {
    key: 2,
    value: '落札承諾待ち(繰り上げ可)',
  },
  {
    key: 3,
    value: '落札承諾済み',
  },
  {
    key: 5,
    value: '繰り上げの承諾待ち',
  },
  {
    key: 6,
    value: '繰り上げの承諾待ち<p>(繰り上げ可)</p>',
  },
  {
    key: 7,
    value: '繰り上げの承諾済み',
  },
  {
    key: 4,
    value: '終了',
    color: 'gray',
  },
  {
    key: 8,
    value: '終了',
    color: 'gray',
  },
  {
    key: 9,
    value: '終了',
    color: 'gray',
  },
  {
    key: 11,
    value: '終了',
    color: 'gray',
  },
];

export const FORWARDER_STATUS = [
  {
    key: 5,
    value: '回答が必要',
    color: 'yellow',
  },
  {
    key: 6,
    value: '回答が必要<p>(繰り上げの可能性あり)</p>',
    color: 'yellow',
  },
  {
    key: 7,
    value: '繰り上げ承諾済み',
    color: 'yellow',
  },
  {
    key: 8,
    value: '繰り上げ辞退済み',
    color: 'yellow',
  },
  {
    key: 9,
    value: '繰り上げ取り消し',
    color: 'red',
  },
  {
    key: 10,
    value: '繰り上げ取り消し',
    color: 'red',
  },
];
